import React, { useEffect, useState } from 'react';
import './LandingPricing.css';

const PALETTE = ['#27ae60', '#2980b9', '#8e44ad', '#e67e22', '#c0392b', '#16a085'];

function formatVal(val, type) {
    if (val === null || val === undefined || val === false || val === 0) return null;
    if (type === 'bool') return '✓';
    if (type === 'int') return val === -1 ? '∞' : String(val);
    if (type === 'price') return val === 0 ? 'Бесплатно' : `${Number(val).toLocaleString('ru')} ₽`;
    return String(val);
}

export default function LandingPricing({ onRegisterClick }) {
    const [catalog, setCatalog] = useState(null);

    useEffect(() => {
        fetch('/api/v1/billing/tool-catalog')
            .then(r => r.ok ? r.json() : null)
            .then(d => d && setCatalog(d))
            .catch(() => {});
    }, []);

    if (!catalog) return null;

    const { plans, categories } = catalog;
    const idx = plans.findIndex(p => p.popular);
    const popularIdx = idx >= 0 ? idx : plans.findIndex(p => p.price_monthly > 0);
    console.log('Plans:', plans.map(p => ({ key: p.key, popular: p.popular, price: p.price_monthly })), 'Popular idx:', popularIdx);

    return (
        <div className="lp">
            {/* Plan cards */}
            <div className="lp__plans">
                {plans.map((plan, idx) => (
                    <div
                        key={plan.key}
                        className={`lp__plan ${idx === popularIdx ? 'lp__plan--popular' : ''}`}
                        style={{ '--pc': PALETTE[idx % PALETTE.length] }}
                    >
                        {idx === popularIdx && <div className="lp__popular-badge">Популярный</div>}
                        <div className="lp__plan-name">{plan.label}</div>
                        <div className="lp__plan-price">
                            {plan.price_monthly === 0
                                ? <span className="lp__plan-free">Бесплатно</span>
                                : <>
                                    <span className="lp__plan-amount">{plan.price_monthly.toLocaleString('ru')} ₽</span>
                                    <span className="lp__plan-period"> / мес</span>
                                </>
                            }
                        </div>
                        {plan.price_daily > 0 && (
                            <div className="lp__plan-daily">{plan.price_daily.toLocaleString('ru', { maximumFractionDigits: 2 })} ₽/день</div>
                        )}
                        <button
                            type="button"
                            className={`lp__cta ${idx === popularIdx ? 'lp__cta--primary' : 'lp__cta--ghost'}`}
                            onClick={onRegisterClick}
                        >
                            {plan.price_monthly === 0 ? 'Начать бесплатно' : 'Зарегистрироваться'}
                        </button>
                    </div>
                ))}
            </div>

            {/* Feature comparison */}
            <div className="lp__compare">
                <table className="lp__table">
                    <thead>
                        <tr>
                            <th className="lp__th-feature">Возможности</th>
                            {plans.map((p, idx) => (
                                <th key={p.key} className="lp__th-plan" style={{ '--pc': PALETTE[idx % PALETTE.length] }}>
                                    {p.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map(cat => (
                            <React.Fragment key={cat.key}>
                                <tr className="lp__cat-row">
                                    <td colSpan={plans.length + 1} className="lp__cat-label">
                                        {cat.label}
                                    </td>
                                </tr>
                                {cat.tools.map(tool => {
                                    const cells = plans.map(p => formatVal(tool.plan_values[p.key], tool.type));
                                    if (cells.every(c => !c)) return null;
                                    return (
                                        <tr key={tool.key} className="lp__tool-row">
                                            <td className="lp__tool-name">
                                                {tool.icon && <span className="lp__tool-icon">{tool.icon}</span>}
                                                <span>
                                                    {tool.title}
                                                    {tool.state === 'beta' && <span className="lp__beta-badge">beta</span>}
                                                </span>
                                            </td>
                                            {plans.map((p, i) => (
                                                <td key={p.key} className={`lp__val ${cells[i] ? 'lp__val--yes' : 'lp__val--no'}`}>
                                                    {cells[i] || '—'}
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
